// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form_input[data-v-d7757da6]{display:inline-block;width:300px;margin-right:20px}.form_name[data-v-d7757da6]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
